/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePaymentRequest } from '../models/CreatePaymentRequest';
import type { ECPayOrderParams } from '../models/ECPayOrderParams';
import type { QueryCreditTransactionRequest } from '../models/QueryCreditTransactionRequest';
import type { RefundPaymentRequest } from '../models/RefundPaymentRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EcPayService {
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiEcPayGenerateCheckMacValue(
        requestBody?: ECPayOrderParams,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ECPay/GenerateCheckMacValue',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiEcPayCreatePayment(
        requestBody?: CreatePaymentRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ECPay/CreatePayment',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public static postApiEcPayCallback(
        formData?: {
            MerchantID: string;
            MerchantTradeNo: string;
            RtnCode: number;
            StoreID?: string;
            RtnMsg?: string;
            TradeNo?: string;
            TradeAmt?: number;
            PaymentDate?: string;
            PaymentType?: string;
            PaymentTypeChargeFee?: number;
            TradeDate?: string;
            SimulatePaid?: number;
            CustomField1?: string;
            CustomField2?: string;
            CustomField3?: string;
            CustomField4?: string;
            CheckMacValue?: string;
            gwsr?: string;
            IsPaymentSuccessful?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ECPay/callback',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiEcPayProcessPaymentResult(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ECPay/process-payment-result',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiEcPayTestValidateCheckmacRawbody(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ECPay/test-validate-checkmac-rawbody',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiEcPayRefund(
        requestBody?: RefundPaymentRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ECPay/refund',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiEcPayQueryCreditTransaction(
        requestBody?: QueryCreditTransactionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ECPay/query-credit-transaction',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
